interface BottomNavProps {
  activeTab: 'vote' | 'badges' | 'vibes' | 'leaderboard' | 'settings'
  onTabChange: (tab: 'vote' | 'badges' | 'vibes' | 'leaderboard' | 'settings') => void
}

export default function BottomNav({ activeTab, onTabChange }: BottomNavProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-black/20 backdrop-blur-md border-t border-white/10 pb-safe">
      <div className="container mx-auto flex items-center justify-around h-20 px-2 max-w-lg">
        {/* Vote Tab */}
        <button
          onClick={() => onTabChange('vote')}
          className={`flex flex-col items-center justify-center gap-1.5 px-2 py-2 transition-all duration-300 w-16 ${activeTab === 'vote'
              ? 'text-cyan-400 scale-105'
              : 'text-gray-500 hover:text-gray-300'
            }`}
        >
          <div className={`p-1 rounded-full ${activeTab === 'vote' ? 'bg-cyan-500/10' : ''}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={activeTab === 'vote' ? 2.5 : 2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <span className="text-[10px] font-bold uppercase tracking-wider">Vote</span>
        </button>

        {/* Badges Tab */}
        <button
          onClick={() => onTabChange('badges')}
          className={`flex flex-col items-center justify-center gap-1.5 px-2 py-2 transition-all duration-300 w-16 ${activeTab === 'badges'
              ? 'text-cyan-400 scale-105'
              : 'text-gray-500 hover:text-gray-300'
            }`}
        >
          <div className={`p-1 rounded-full ${activeTab === 'badges' ? 'bg-cyan-500/10' : ''}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={activeTab === 'badges' ? 2.5 : 2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
              />
            </svg>
          </div>
          <span className="text-[10px] font-bold uppercase tracking-wider">Badges</span>
        </button>

        {/* Vibes Tab */}
        <button
          onClick={() => onTabChange('vibes')}
          className={`flex flex-col items-center justify-center gap-1.5 px-2 py-2 transition-all duration-300 w-16 ${activeTab === 'vibes'
              ? 'text-cyan-400 scale-105'
              : 'text-gray-500 hover:text-gray-300'
            }`}
        >
          <div className={`p-1 rounded-full ${activeTab === 'vibes' ? 'bg-cyan-500/10' : ''}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={activeTab === 'vibes' ? 2.5 : 2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              />
            </svg>
          </div>
          <span className="text-[10px] font-bold uppercase tracking-wider">Vibes</span>
        </button>

        {/* Leaderboard Tab */}
        <button
          onClick={() => onTabChange('leaderboard')}
          className={`flex flex-col items-center justify-center gap-1.5 px-2 py-2 transition-all duration-300 w-16 ${activeTab === 'leaderboard'
              ? 'text-cyan-400 scale-105'
              : 'text-gray-500 hover:text-gray-300'
            }`}
        >
          <div className={`p-1 rounded-full ${activeTab === 'leaderboard' ? 'bg-cyan-500/10' : ''}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={activeTab === 'leaderboard' ? 2.5 : 2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
              />
            </svg>
          </div>
          <span className="text-[10px] font-bold uppercase tracking-wider">Ranks</span>
        </button>

        {/* Settings Tab */}
        <button
          onClick={() => onTabChange('settings')}
          className={`flex flex-col items-center justify-center gap-1.5 px-2 py-2 transition-all duration-300 w-16 ${activeTab === 'settings'
              ? 'text-cyan-400 scale-105'
              : 'text-gray-500 hover:text-gray-300'
            }`}
        >
          <div className={`p-1 rounded-full ${activeTab === 'settings' ? 'bg-cyan-500/10' : ''}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={activeTab === 'settings' ? 2.5 : 2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          </div>
          <span className="text-[10px] font-bold uppercase tracking-wider">Settings</span>
        </button>
      </div>
    </nav>
  )
}

